module.exports = __webpack_public_path__ + "static/media/29BDOS8.f48d5f70.jpg";